import { t } from 'i18next';
import {
  Field,
  QueryBuilder as QueryBuilderCustom,
  RuleGroupType,
  RuleType
} from 'react-querybuilder';
import { QueryBuilderBootstrap } from '@react-querybuilder/bootstrap';

import 'bootstrap-icons/font/bootstrap-icons.scss';
import 'react-querybuilder/dist/query-builder.scss';
import './QueryBuilder.scss';

const TRANSLATIONS: object = {
  addRule: {
    label: t('components.query_builder_add_rule_label'),
    title: t('components.query_builder_add_rule_title')
  },
  addGroup: {
    label: t('components.query_builder_add_group_label'),
    title: t('components.query_builder_add_group_title')
  },
  removeGroup: {
    label: '⨯',
    title: t('components.query_builder_remove_group_title')
  },
  removeRule: {
    label: '⨯',
    title: t('components.query_builder_remove_rule_title')
  }
};

interface Props {
  fields: Field[];
  query: RuleGroupType;
  onQueryChange?: Setter<RuleGroupType<RuleType<string>, string>>;
}

const QueryBuilder = ({ fields, query, onQueryChange }: Props) => {
  return (
    <QueryBuilderBootstrap>
      <QueryBuilderCustom
        controlClassnames={{ queryBuilder: 'queryBuilder-branches' }}
        fields={fields}
        query={query}
        translations={TRANSLATIONS}
        onQueryChange={onQueryChange}
      />
    </QueryBuilderBootstrap>
  );
};

export default QueryBuilder;
